import React from "react";
import { withRouter } from "react-router-dom";
import { Typography, makeStyles, createStyles } from "@material-ui/core";
//import Button from "@material-ui/core/Button";
//import {SlButton} from '@softix/ui-components/dist/stx-components-react/src/components';

import { ITheme } from "../../Layout/themes";

const useStyles = makeStyles(({ palette, breakpoints }: ITheme) => {
  return createStyles({
    root: {
      paddingTop: 60,
      [breakpoints.down("sm")]: {
        paddingTop: 20
      }
    },
    title: {
      textAlign: "center",
      color: "#001828"
    },

    btnBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: 40,
      marginTop: 40,
      [breakpoints.down("sm")]: {
        flexDirection: "column",
        marginBottom: 34
      }
    },

    signInButton: {
      width: 108,
      height: 40,
      borderRadius: 5,
      boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.3)",
      backgroundColor: "white",
      "&:hover": {
        backgroundColor: "white"
      },
      [breakpoints.down("sm")]: {
        width: "100%"
      }
    },
    signInButtonText: {
      color: palette.primary.main,
      textTransform: "none"
    }
  });
});

export const NotFoundComponent = ({ history }) => {
  const classes = useStyles({});

  const handleRedirect2Homepage = () => {
    // window.location.href = currentContent.HOMEPAGE_URL;
  };

  return (
    <div className={classes.root}>
      <Typography variant="h1" className={classes.title}>
        Sorry, page not found.
      </Typography>

      <div className={classes.btnBox}>
        <sl-button
          type="default"
          size="large"
          onClick={handleRedirect2Homepage}
        >
            Home page
          </sl-button>
      </div>
    </div>
  );
};

export const NotFound = withRouter(NotFoundComponent);
